import { ConditionDefinition, FeatureDefinition } from 'core/funnel/store/selectors';
import { Offer } from './Offer';

export type Offers = {
  defaultOffers: Array<Offer>;
  timeUpOffers: Array<Offer>;
  discountOffers: Array<Offer>;
  upsells: Record<string, Offer>;
  discountUpsells: Record<string, Offer>;
  condition?: ConditionDefinition;
  feature?: FeatureDefinition;
};

export const emptyOffers: Offers = {
  defaultOffers: [],
  timeUpOffers: [],
  discountOffers: [],
  upsells: {},
  discountUpsells: {},
};
